import React from 'react'
import Box from '@material-ui/core/Box'
import TipWell, { TipWellActionButton } from 'components/tip-well'
import InfoOutlinedIcon from 'components/material-symbol/icons/Info'
import ErrorOutlineOutlinedIcon from 'components/material-symbol/icons/ErrorOutline'
import ReportProblemOutlinedIcon from 'components/material-symbol/icons/ReportProblem'
import {
  INCOMPLETE_STRIPE_SETUP_TIP,
  CHARGES_DISABLED_OR_ACCOUNT_DELETED_TIP,
  PAYOUTS_DISABLED_TIP,
} from 'utils/constants'

const CompleteSetupAction = ({ onOpen }) => {
  const handleOpen = event => {
    event.preventDefault()
    event.stopPropagation()
    onOpen()
  }

  return (
    <TipWellActionButton
      type="button"
      onMouseDown={handleOpen}
      onClick={handleOpen}
    >
      Complete Setup
    </TipWellActionButton>
  )
}

const PaymentAccountWarning = ({
  paymentAccount,
  onOpen,
  hasUnresolvedPaymentAccount = false,
}) => {
  const { detailsSubmitted, chargesEnabled, payoutsEnabled, deletedAt } =
    paymentAccount || {}
  const isDeletedPaymentAccount =
    deletedAt != null || hasUnresolvedPaymentAccount

  if (
    (!paymentAccount && !hasUnresolvedPaymentAccount) ||
    (paymentAccount && detailsSubmitted && chargesEnabled && payoutsEnabled)
  ) {
    return null
  }

  const renderWarning = (key, caption, icon, variant, showAction = true) => (
    <Box key={key} mb={2}>
      <TipWell
        variant={variant}
        icon={icon}
        caption={caption}
        action={showAction ? <CompleteSetupAction onOpen={onOpen} /> : null}
      />
    </Box>
  )

  const warningBlocks = []

  if (!detailsSubmitted && !isDeletedPaymentAccount) {
    warningBlocks.push(
      renderWarning(
        'details-not-submitted',
        INCOMPLETE_STRIPE_SETUP_TIP,
        InfoOutlinedIcon,
        'neutral',
      ),
    )
    return warningBlocks
  }

  if (!chargesEnabled || isDeletedPaymentAccount) {
    warningBlocks.push(
      renderWarning(
        'charges-not-enabled',
        CHARGES_DISABLED_OR_ACCOUNT_DELETED_TIP,
        ErrorOutlineOutlinedIcon,
        'error',
        !isDeletedPaymentAccount,
      ),
    )
  }

  if (!payoutsEnabled && !isDeletedPaymentAccount) {
    warningBlocks.push(
      renderWarning(
        'payouts-not-enabled',
        PAYOUTS_DISABLED_TIP,
        ReportProblemOutlinedIcon,
        'warning',
      ),
    )
  }

  return <>{warningBlocks}</>
}

export default PaymentAccountWarning
